import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';
import { useLoadEditorDependencies } from 'ProtectedRoute/useLoadEditorDependencies';
import { StreamEditor } from 'StreamEditor';

export function EditStreamComponent() {
    // The editor bundle is still needed: TranslatableLessonExportSet builds each translatable file
    // by compiling an Angular template, so the export stays in Angular.
    useLoadEditorDependencies();
    const [key, params] = useAngularToReactRoute<{ streamId: string }>();

    // The route pattern requires the id, so it is always there by the time this renders.
    return <StreamEditor key={key} streamId={params.streamId!} />;
}
